<template>
    <div class="d-flex flex-column position-relative">
        <key-value-cell horizontal :value="cubeDetails.userName">姓名</key-value-cell>
        <key-value-cell horizontal :value="cubeDetails.dateStr">日期</key-value-cell>

        <b-badge :variant="item.operationId === operationId ? 'success' : 'light'" pill class="mt-1 cursor-pointer"
                 v-for="(item,index) of selectedCubeValues" :key="index"
                 @click="operationId=item.operationId">
            {{ item.fromTime.substring(11, 16) }}-{{ item.toTime.substring(11, 16) }}
        </b-badge>
        <empty-list-info v-if="selectedCubeValues.length===0"></empty-list-info>

        <template v-if="operationId !== ''">
            <KeyValueCell horizontal :value="ppOperation.projectCode">项目号</KeyValueCell>
            <KeyValueCell horizontal :value="ppOperation.projectName">项目名称</KeyValueCell>
            <KeyValueCell horizontal :value="ppOperation.orderCode">工单编号</KeyValueCell>
            <KeyValueCell horizontal :value="ppOperation.operationSeq">工序编号</KeyValueCell>
            <KeyValueCell horizontal :value="headCount">人数</KeyValueCell>
            <KeyValueCell horizontal :value="ppOperation.workHour+'H'">标准工时</KeyValueCell>
            <KeyValueCell horizontal :value="ppOperation.prdPpStatusName">工序状态</KeyValueCell>
            <KeyValueCell horizontal :value="ppOperation.forecastBeginTime">计划开始</KeyValueCell>
            <KeyValueCell horizontal :value="ppOperation.forecastFinishTime">计划结束</KeyValueCell>
            <KeyValueCell horizontal :value="ppOperation.forecastMstLocationName">计划工作中心</KeyValueCell>
            <KeyValueCell horizontal :value="ppOperation.actualBeginTime">实际开始时间</KeyValueCell>
            <KeyValueCell :value="ppOperation.operationDescription">工序描述</KeyValueCell>
        </template>

        <button type="button"
                class="close position-absolute right-top"
                @click="$store.dispatch('manLoad/clearSelect')"
                aria-label="关闭">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</template>

<script>
import {mapState} from "vuex";
import EmptyListInfo from "@/components/echarts-part/CalendarShift/cells/stuffs/EmptyListInfo";
import KeyValueCell from "@/views/sithMes/prd/PrdOperationExcute/cells/KeyValueCell";

export default {
    name: "ManLoadDetails",
    components: {KeyValueCell, EmptyListInfo},
    computed: {
        ...mapState({
            operationMap: state => state.manLoad.operationMap,
        }),
        cubeDetails(){
            return this.$store.getters['manLoad/cubeDetails'];
        },
        selectedCubeValues() {
            return this.cubeDetails.values;
        },
        ppOperation() {
            return this.operationMap[this.operationId];
        },
        headCount() {
            return this.ppOperation.headCount > 0 ? this.ppOperation.headCount + '位' : '无'
        },
    },
    data() {
        return {
            operationId: ''
        }
    },
    watch: {
        selectedCubeValues:{
            handler(val) {
                if (!val.some(o => o.operationId === this.operationId)) {
                    this.operationId = '';
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.right-top {
    right: 0.6rem;
    top: 0.6rem;
}
</style>